import { render, staticRenderFns } from "./cv4.vue?vue&type=template&id=cb22598a&scoped=true&"
import script from "./cv4.vue?vue&type=script&lang=js&"
export * from "./cv4.vue?vue&type=script&lang=js&"
import style0 from "./cv4.vue?vue&type=style&index=0&id=cb22598a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb22598a",
  null
  
)

export default component.exports